import { publicRuntimeConfig } from "../../../config/publicRuntimeConfig";

export class SaveRequestTimeoutError extends Error {
  constructor(timeoutMs: number) {
    super(`The request timed out after ${Math.round(timeoutMs / 1000)} second(s).`);
    this.name = "SaveRequestTimeoutError";
  }
}

/**
 * Runs a single manage-page save request under the `API_TIMEOUT` budget.
 *
 * Scoped deliberately to this page's save path rather than the shared API client:
 * other callers need their own budgets, and `dbManager.service` sets a 90s one.
 *
 * On expiry the returned promise rejects, so a downstream that never responds
 * surfaces as a failed write instead of an indefinite "Saving…".
 */
export function withSaveTimeout<T>(run: () => Promise<T>): Promise<T> {
  const timeoutMs = publicRuntimeConfig.apiTimeoutMs;

  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new SaveRequestTimeoutError(timeoutMs)), timeoutMs);

    run()
      .then(resolve, reject)
      .finally(() => clearTimeout(timer));
  });
}
